module.exports = __webpack_public_path__ + "assets/img/img170.80685dff.png";